import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { Moment } from 'moment';
import { CertificateRecord } from '../models/certificate-record';

export class SetCertificateRecord {
    static readonly type = '[CertificateRecord] SetCertificateRecord';

    constructor(public payload: CertificateRecord) {}
}

export class UnsetCertificateRecord {
    static readonly type = '[CertificateRecord] UnsetCertificateRecord';
}

export class FetchCertificateRecord {
    static readonly type = '[CertificateRecord] FetchCertificateRecord';

    constructor(public payload: string) {}
}

export class FetchCertificateRecordSuccess {
    static readonly type = '[CertificateRecord] FetchCertificateRecordSuccess';

    constructor(public payload: CertificateRecord) {}
}

export class FetchCertificateRecordFailure {
    static readonly type = '[CertificateRecord] FetchCertificateRecordFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddCertificateRecords {
    static readonly type = '[CertificateRecord] AddCertificateRecords';

    constructor(public payload: CertificateRecord[]) {}
}

export class AddCertificateRecord {
    static readonly type = '[CertificateRecord] AddCertificateRecord';

    constructor(
        public payload: {
            certificationId: string;
            issueDate: Moment;
            expirationDate: Moment;
            sendNotification: boolean;
            userId: string;
            file?: File;
            notifyAboutExpiration?: boolean;
        }
    ) {}
}

export class AddCertificateRecordSuccess {
    static readonly type = '[CertificateRecord] AddCertificateRecordSuccess';
}

export class AddCertificateRecordFailure {
    static readonly type = '[CertificateRecord] AddCertificateRecordFailure';
}

export class AssignCertificateToModuleUser {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUser';

    constructor(
        public payload: {
            participantId: string;
            certificationId: string;
            issueDate: Moment;
            expirationDate: Moment;
            sendNotification: boolean;
            file?: File;
        }
    ) {}
}

export class AssignCertificateToModuleUserSuccess {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUserSuccess';

    constructor(public payload: { existing: CertificateRecord[]; newlyAssigned: CertificateRecord[]; replaced: CertificateRecord[] }) {}
}

export class AssignCertificateToModuleUserFailure {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUserFailure';
}

export class AssignCertificateToModuleUsers {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUsers';

    constructor(
        public payload: {
            moduleUserIds: string[];
            moduleCertificationIds: string[];
            sendNotification: boolean;
        }
    ) {}
}

export class AssignCertificateToModuleUsersSuccess {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUsersSuccess';

    constructor(public payload: { existing: CertificateRecord[]; newlyAssigned: CertificateRecord[]; replaced: CertificateRecord[] }) {}
}

export class AssignCertificateToModuleUsersFailure {
    static readonly type = '[CertificateRecord] AssignCertificateToModuleUsersFailure';
}

export class CreateCertificateRecord {
    static readonly type = '[CertificateRecord] CreateCertificateRecord';

    constructor(public payload: CertificateRecord) {}
}

export class CreateCertificateRecordSuccess {
    static readonly type = '[CertificateRecord] CreateCertificateRecordSuccess';

    constructor(public payload: CertificateRecord) {}
}

export class CreateCertificateRecordFailure {
    static readonly type = '[CertificateRecord] CreateCertificateRecordFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertificateRecord {
    static readonly type = '[CertificateRecord] UpdateCertificateRecord';

    constructor(public payload: { certificateRecordId: string; certificationId: string; issueDate: Moment; expirationDate: Moment; notifyAboutExpiration: boolean }) {}
}

export class UpdateCertificateRecordSuccess {
    static readonly type = '[CertificateRecord] UpdateCertificateRecordSuccess';

    constructor(public payload: CertificateRecord) {}
}

export class UpdateCertificateRecordFailure {
    static readonly type = '[CertificateRecord] UpdateCertificateRecordFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteCertificateRecord {
    static readonly type = '[CertificateRecord] DeleteCertificateRecord';

    constructor(public payload: string) {}
}

export class DeleteCertificateRecordSuccess {
    static readonly type = '[CertificateRecord] DeleteCertificateRecordSuccess';

    constructor(public payload: string) {}
}

export class DeleteCertificateRecordFailure {
    static readonly type = '[CertificateRecord] DeleteCertificateRecordFailure';

    constructor(public payload: string) {}
}

export class SetCertificateRecords {
    static readonly type = '[CertificateRecord] SetCertificateRecords';

    constructor(public payload: CertificateRecord[]) {}
}

export class FetchCertificateRecords {
    static readonly type = '[CertificateRecord] FetchCertificateRecords';
}

export class FetchCertificateRecordsSuccess {
    static readonly type = '[CertificateRecord] FetchCertificateRecordsSuccess';
}

export class FetchCertificateRecordsFailure {
    static readonly type = '[CertificateRecord] FetchCertificateRecordsFailure';
}

export class UnsetCertificateRecordAll {
    static readonly type = '[CertificateRecord] UnsetCertificateRecordAll';
}

export class FetchUserCourseCertificates {
    static readonly type = '[CertificateRecord] FetchUserCourseCertificates';

    constructor(
        public payload: {
            userId: string;
            pageSize?: number;
            pageNumber?: number;
            search?: string;
        }
    ) {}
}

export class FetchUserCourseCertificatesSuccess {
    static readonly type = '[CertificateRecord] FetchUserCourseCertificatesSuccess';

    constructor(public payload: CertificateRecord[]) {}
}

export class FetchUserCourseCertificatesFailure {
    static readonly type = '[CertificateRecord] FetchUserCourseCertificatesFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class SetUserCourseCertificates {
    static readonly type = '[CertificateRecord] SetUserCourseCertificates';

    constructor(public payload: CertificateRecord[]) {}
}
